import GradientContainer from "@app/components/gradient/gradient-container";
import Image from "next/image";

const ExpectationSectionMidContent = () => {
  return (
    <div className="flex flex-col space-y-8 md:space-y-12 lg:space-y-24">
      <div className="flex flex-col items-center space-y-8 text-center">
        <div className="flex flex-col items-center space-y-2">
          <span className="mobile-h3 md:h4 lg:h3 text-base-dark">
            {"Let's exceed expectations"}
          </span>
          <GradientContainer>
            <div className="h-2 w-36" />
          </GradientContainer>
        </div>
        <span className="subheading text-text-color-mid-em">
          Industry solutions your customers will love.
        </span>
      </div>
      <div className="grid grid-cols-12 gap-y-8">
        <div className="col-span-12 md:col-span-6 md:p-12 lg:p-24 flex items-center justify-end">
          <div className="lg:max-w-[528px] flex flex-col items-start justify-center space-y-4 ">
          <Image
            src="/assets/icons/mdi-circuit-chip.png"
            alt="Technology Advantages"
            height={40}
            width={40}
          />
          <span className="mobile-h4 md:h5 lg:h4 text-text-color-high-em">
            Technology Advantages
          </span>
          <span className="text-text-color-mid-em">
            Our platform is guaranteed to deliver the innovation your customers
            have been looking for. Stay updated on rollout progress with the
            SimpleWaste partner-facing interface: review customer experience,
            opportunity, and KPIs.​
          </span>
          </div>
        </div>
        <div className="col-span-12 md:col-span-6">
          <div
            className="min-h-[200px] xs:min-h-[400px] md:min-h-[560px] h-full w-full bg-cover bg-top bg-no-repeat
          rounded-xl md:rounded-tr-none md:rounded-br-none md:rounded-tl-xl md:rounded-bl-xl"
            style={{
              backgroundImage: "url('/images/partners/expectations-02.png')",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ExpectationSectionMidContent;
